import type { IPublicationPackages } from '../../../../repositories/billing-tariffs/entities/PublishTerms/PublicationPackages';
import { IPublicationPackagesState } from '../../../../reducers/v2';
import { mapTariffId } from './mapTariffId';
import { mapServiceId } from './mapServiceId';
import { defaultTo } from 'ramda';

export function mapPublicationPackages(packages?: IPublicationPackages): IPublicationPackagesState {
  return {
    packagesList:
      packages?.servicePackages?.map(_package => ({
        id: '',
        packageId: _package.tariffIdentificator!.packageId,
        selected: _package.isSelected,
        marketingPrice: _package.marketingPrice,
        price: _package.price,
        days: _package.days || 0,
        token: _package.token || '',
        label: _package.label || '',
        offersCount: 0,
        tariffIdentificator: mapTariffId(_package.tariffIdentificator!),
        endDate: defaultTo(new Date().toDateString(), _package.endDate),
        serviceId: mapServiceId(_package.tariffIdentificator!.serviceTypes![0]),
        type: _package.type,
      })) || [],
    disabled: Boolean(packages?.isDisabled),
  };
}
